// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@ces/App/Components/Common/XngZone";
import { CustomAppState } from "@ces/App/Store/Reducers";
import { xIsAuthenticated } from "@ces/App/Store/Selectors/GeneralSelectors";
import { XNGAGE_CUSTOM_WIDGET } from "@ces/XDL/constants";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => ({
    session: getSession(state),
    isAuthenticated: xIsAuthenticated(state),
    billToState: getCurrentBillToState(state),
});

interface OwnProps extends WidgetProps {}

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

interface MyAccountDashboardTitleStyles {
    wrapper?: InjectableCss;
    homeSelectorWrapper?: InjectableCss;
    myDashboardTitleWrapper?: InjectableCss;
}

export const myAccountDashboardTitleStyles: MyAccountDashboardTitleStyles = {};

const styles = myAccountDashboardTitleStyles;

const MyAccountDashboardTitle = ({ id }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="MyAccountDashboardTitle">
            <StyledWrapper {...styles.myDashboardTitleWrapper}>
                <XngZone contentId={id} zoneName="MyDashboardTitle" hint="Page Title and Home Page Selector"></XngZone>
            </StyledWrapper>
            <StyledWrapper {...styles.homeSelectorWrapper}>
                <XngZone contentId={id} zoneName="MyDashboardHomeSelector" hint=" Home Page Selector"></XngZone>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyAccountDashboardTitle),
    definition: {
        group: XNGAGE_CUSTOM_WIDGET,
        fieldDefinitions: [],
    },
};

export default widgetModule;
